
// packages
import { Box, Typography, Stack, TextField} from '@mui/material'
import { useMediaQuery } from '@mui/material';

// local
import { useGetUserAnswerQuery } from '../../api';


const LiveAnswersModal = ({examComponentId}) => {
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // DEFINITIONS
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const isMobile = useMediaQuery("(max-width:600px)");
  
    const letterMap = {
        1: 'A',
        2: 'B',
        3: 'C',
        4: 'D'
      };
    

    const {
      data: userAnswerData,
      loading: userAnswerLoading,
      error: userAnswerError,
    } = useGetUserAnswerQuery(null, examComponentId);
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // STYLES 
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '70vw',
        maxHeight: '70vh',
        bgcolor: 'background.paper',
        borderRadius: 4,
        boxShadow: 24,
        p: 4,
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
      };

    const mobileModalStyle = {
        ...modalStyle,
        width: '95vw',
      };


    return (
        <Box sx={!isMobile ? (modalStyle) : (mobileModalStyle)}>
          <Typography variant='h5' sx={!isMobile?({ mb: 2 }):({ mb: 2, mt:2 })}>User Answers</Typography>
          {userAnswerData && userAnswerData.data.length > 0 && (
            <>
              {userAnswerData.data.sort((a,b) => {
                return a.question_number - b.question_number
              }).map((answerObj) => {
                if (answerObj.written_answer) {
                  return (
                    <Stack>
                      <Typography sx={{marginBottom:2, fontWeight:700}}>{answerObj.question_number}. {answerObj.question_text}</Typography>
                      <Box sx={{borderStyle:'solid', padding:1, borderRadius:2, borderColor:'#D3D3D3'}}>
                        <Typography>{answerObj.written_answer}</Typography>
                      </Box>
                    </Stack>
                  )
                } else {
                  return (
                    <Stack>
                      <Typography sx={{marginBottom:2, fontWeight:700}}>{answerObj.question_number}. {answerObj.selected_option ? letterMap[answerObj.selected_option] : '--'}</Typography>
                    </Stack>
                  )
                }
              })}
            </>
          )}
        </Box>
    );
}

export default LiveAnswersModal;